import React from 'react';
import { Box } from '@material-ui/core';
import FormFieldFactory from './FormFieldFactory';

const Form = ({ fields, onChangeFields }) => {
  fields = fields.filter((x) => typeof x.enabled === 'undefined' || x.enabled);

  const handleChangeField = (event) => {
    let { name, value, checked, type } = event.target;

    if (type === 'checkbox') {
      value = checked;
    }

    let newFormFieldsValues = [];

    fields.forEach((field) => {
      newFormFieldsValues.push(
        field.name === name ? { ...field, value: value } : field
      );
    });

    onChangeFields(newFormFieldsValues, {
      name,
      value
    });
  };

  return (
    <form>
      <Box>
        {fields.map((field) => {
          return FormFieldFactory({ field, handleChangeField });
        })}
      </Box>
    </form>
  );
};

export default Form;
